import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Spinner } from 'react-bootstrap';
import { FiRefreshCw, FiCalendar, FiClock, FiChevronRight } from 'react-icons/fi';
import { formatReferenceDate, formatGeneratedAt } from '../utils/dateHelpers';

const DashboardPageHeader = ({
    title,
    icon: Icon,
    referenceDate,
    currentHourParis,
    metadata,
    onRefresh,
    refreshing = false,
    breadcrumb,
}) => {
    const hasHour = currentHourParis !== undefined && currentHourParis !== null;

    return (
        <header className="ops-header">
            <div className="ops-header__main">
                {breadcrumb?.length > 0 && (
                    <nav aria-label="Fil d’Ariane">
                        <ol className="ops-breadcrumb">
                            {breadcrumb.map((item, index) => {
                                const isLast = index === breadcrumb.length - 1;
                                return (
                                    <li key={item.label} className="ops-breadcrumb__item">
                                        {item.to && !isLast ? (
                                            <Link to={item.to} className="ops-breadcrumb__link">{item.label}</Link>
                                        ) : (
                                            <span aria-current={isLast ? 'page' : undefined}>{item.label}</span>
                                        )}
                                        {!isLast && <FiChevronRight className="ops-breadcrumb__sep" aria-hidden="true" />}
                                    </li>
                                );
                            })}
                        </ol>
                    </nav>
                )}

                <h1 className="ops-header__title">
                    {Icon && (
                        <span className="ops-header__icon" aria-hidden="true">
                            <Icon />
                        </span>
                    )}
                    {title}
                </h1>

                {(referenceDate || metadata || hasHour) && (
                    <ul className="ops-header__meta" aria-label="Informations de mise à jour">
                        {referenceDate && (
                            <li>
                                <FiCalendar aria-hidden="true" />
                                Référence <strong>{formatReferenceDate(referenceDate)}</strong>
                            </li>
                        )}
                        {hasHour && (
                            <li>
                                <FiClock aria-hidden="true" />
                                Heure Paris <strong>{currentHourParis}h</strong>
                            </li>
                        )}
                        {metadata && (
                            <li>
                                <FiRefreshCw aria-hidden="true" />
                                Dernière mise à jour <strong>{formatGeneratedAt(metadata.generated_at)}</strong>
                                {metadata.processing_time_ms !== undefined && (
                                    <span className="ops-header__meta-dim">({metadata.processing_time_ms} ms)</span>
                                )}
                            </li>
                        )}
                    </ul>
                )}
            </div>

            <div className="ops-header__actions">
                <span className="visually-hidden" aria-live="polite">
                    {refreshing ? 'Actualisation des données en cours' : ''}
                </span>
                <Button
                    variant="primary"
                    className="ops-btn ops-btn--primary"
                    onClick={onRefresh}
                    disabled={refreshing}
                    aria-label="Actualiser le tableau de bord"
                >
                    {refreshing ? (
                        <Spinner animation="border" size="sm" aria-hidden="true" />
                    ) : (
                        <FiRefreshCw aria-hidden="true" />
                    )}
                    <span>{refreshing ? 'Actualisation…' : 'Actualiser'}</span>
                </Button>
            </div>
        </header>
    );
};

export default DashboardPageHeader;
